module.exports = __webpack_public_path__ + "static/img/photo.f4cc779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/photo.png
// module id = pphd
// module chunks = 1